import React from 'react';
import { Link } from 'react-router-dom';

export default function CarePackages() {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Our Care Packages</h1>
      
      <div className="row g-4">
        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-info text-white">
              <h4>Preconception Care</h4>
            </div>
            <div className="card-body">
              <p>Optimize health before pregnancy</p>
              <ul className="mb-3">
                <li>Health assessments</li>
                <li>Nutrition planning</li>
                <li>Genetic counseling</li>
              </ul>
              <Link to="/preconception-care" className="btn btn-outline-info">Details</Link>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-success text-white">
              <h4>Antenatal Care</h4>
            </div>
            <div className="card-body">
              <p>Complete pregnancy support</p>
              <ul className="mb-3">
                <li>Regular checkups</li>
                <li>Ultrasound scans</li>
                <li>Birth planning</li>
              </ul>
              <Link to="/antenatal-care" className="btn btn-outline-success">Details</Link>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-warning text-dark">
              <h4>Labour Care</h4>
            </div>
            <div className="card-body">
              <p>Safe delivery support</p>
              <ul className="mb-3">
                <li>Pain management</li>
                <li>Delivery preparation</li>
                <li>Newborn care</li>
              </ul>
              <Link to="/labour-care" className="btn btn-outline-warning">Details</Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-5">
          <div className="card h-100">
            <div className="card-header bg-danger text-white">
              <h4>Adolescent Care</h4>
            </div>
            <div className="card-body">
              <p>Sexual health education</p>
              <ul className="mb-3">
                <li>STI prevention</li>
                <li>Relationship guidance</li>
                <li>Mental health support</li>
              </ul>
              <Link to="/adolescent-care" className="btn btn-outline-danger">Details</Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-5">
          <div className="card h-100">
            <div className="card-header bg-dark text-white">
              <h4>Child Care (Under 5)</h4>
            </div>
            <div className="card-body">
              <p>Early childhood development</p>
              <ul className="mb-3">
                <li>Vaccination schedule</li>
                <li>Growth monitoring</li>
                <li>Safety education</li>
              </ul>
              <Link to="/child-care" className="btn btn-outline-dark">Details</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}